<template>
  <div class="row justify-content-center m-0">
    <div class="col-md-10 p-5">
      <swiper
        :spaceBetween="30"
        :centeredSlides="true"
        :autoplay="{
          delay: 3500,
          disableOnInteraction: false,
        }"
        :pagination="{
          clickable: true,
        }"
        :navigation="true"
        :modules="modules"
        :zoom="true"
        class="mySwiper"
      >
        <swiper-slide class="swiper-slide"
          ><img
            src="../assets/haustüren/5002_FD_Außenansicht_Verkehrsweiß+SparklingIron.png "
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5003_FD_Außenansicht_WhiteAlu+Purple.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5004_FD_Außenansicht_Basaltgrey_DarkOxide.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5007_FD_Außenansicht_Nightgrey+DarkSlateKeramik.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5009_FD_Außenansicht_DeepBlack+Stadelholz.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5051_FD_Außenansicht_RAL9016.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5052_FD_Außenansicht_RAL3004.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5101_FD_Außenansicht_RAL9016.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/haustüren/5204_FD_Außenansicht_Verkehrsweiß.png"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img src="../assets/haustüren/5508_FD_Außenansicht_DarkFSM_Golden-Oak.png" class="swiper-slide rundeEcken"
        /></swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<!-- 
HILFE !!
https://swiperjs.com/demos#effect-fade 
-->

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../assets/mySwiper.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
